export default __webpack_public_path__ + "static/media/IITB.6c4b7c08.svg";